module.exports = __webpack_public_path__ + "img/downLoadB.10d22aed.svg";